/*
  Ported from src/components/NoiseDemo.tsx — real Web Audio graph, not a fake
  waveform: AudioBufferSourceNode(noise) -> BiquadFilterNode(lowpass) ->
  GainNode -> AnalyserNode -> destination. Custom element, no framework.
*/
(function () {
  function buildNoiseBuffer(ctx, seconds) {
    seconds = seconds || 3;
    var buffer = ctx.createBuffer(1, ctx.sampleRate * seconds, ctx.sampleRate);
    var data = buffer.getChannelData(0);
    for (var i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
    return buffer;
  }

  class OblivionNoiseDemo extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('[data-noise-canvas]');
      this.playButton = this.querySelector('[data-noise-play]');
      this.playIcon = this.querySelector('[data-noise-play-icon]');
      this.pauseIcon = this.querySelector('[data-noise-pause-icon]');
      this.slider = this.querySelector('[data-noise-slider]');
      this.chaosLabel = this.querySelector('[data-noise-chaos-label]');
      this.clarityLabel = this.querySelector('[data-noise-clarity-label]');
      this.statusEl = this.querySelector('[data-noise-status]');

      this.clarity = Number(this.slider.value);
      this.playing = false;
      this.ready = false;
      this.raf = null;
      this.audioCtx = null;
      this.filter = null;
      this.gain = null;
      this.analyser = null;
      this.source = null;

      this.playButton.addEventListener('click', this.togglePlay.bind(this));
      this.slider.addEventListener('input', this.onSliderInput.bind(this));

      this.updateLabels();
      this.updateStatus();
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.source) {
        try {
          this.source.stop();
        } catch (e) {}
      }
      if (this.audioCtx) this.audioCtx.close().catch(function () {});
    }

    ensureGraph() {
      if (this.audioCtx) return this.audioCtx;
      var AudioCtx = window.AudioContext || window.webkitAudioContext;
      var ctx = new AudioCtx();
      var source = ctx.createBufferSource();
      source.buffer = buildNoiseBuffer(ctx);
      source.loop = true;

      var filter = ctx.createBiquadFilter();
      filter.type = 'lowpass';

      var gain = ctx.createGain();
      var analyser = ctx.createAnalyser();
      analyser.fftSize = 1024;

      source.connect(filter);
      filter.connect(gain);
      gain.connect(analyser);
      analyser.connect(ctx.destination);

      this.audioCtx = ctx;
      this.source = source;
      this.filter = filter;
      this.gain = gain;
      this.analyser = analyser;
      this.ready = true;
      this.updateStatus();
      return ctx;
    }

    onSliderInput() {
      this.clarity = Number(this.slider.value);
      this.updateLabels();

      var t = this.clarity / 100;
      if (this.gain && this.audioCtx) {
        this.gain.gain.setTargetAtTime(0.7 * (1 - t) + 0.015, this.audioCtx.currentTime, 0.08);
      }
      if (this.filter && this.audioCtx) {
        this.filter.frequency.setTargetAtTime(300 + (1 - t) * 5000, this.audioCtx.currentTime, 0.08);
      }
    }

    updateLabels() {
      var t = this.clarity / 100;
      this.chaosLabel.style.opacity = String(0.4 + (1 - t) * 0.6);
      this.clarityLabel.style.opacity = String(0.4 + t * 0.6);
    }

    updateStatus() {
      this.statusEl.textContent = this.ready
        ? this.playing
          ? 'ENC actif — synthèse en cours'
          : 'En pause'
        : 'Cliquez sur play pour activer le moteur audio';
    }

    draw() {
      var analyser = this.analyser;
      var canvas = this.canvas;
      if (!analyser || !canvas) return;
      var ctx2d = canvas.getContext('2d');
      if (!ctx2d) return;
      var bufferLength = analyser.frequencyBinCount;
      var data = new Uint8Array(bufferLength);
      analyser.getByteTimeDomainData(data);

      var w = canvas.width;
      var h = canvas.height;
      ctx2d.clearRect(0, 0, w, h);
      var t = this.clarity / 100;
      var r = Math.round(229 - (229 - 244) * t);
      var g = Math.round(46 + (244 - 46) * t);
      var b = Math.round(6 + (240 - 6) * t);
      ctx2d.strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',0.9)';
      ctx2d.lineWidth = 2;
      ctx2d.beginPath();
      var slice = w / bufferLength;
      var x = 0;
      for (var i = 0; i < bufferLength; i++) {
        var v = data[i] / 128.0;
        var y = (v * h) / 2;
        if (i === 0) ctx2d.moveTo(x, y);
        else ctx2d.lineTo(x, y);
        x += slice;
      }
      ctx2d.stroke();

      this.raf = requestAnimationFrame(this.draw.bind(this));
    }

    async togglePlay() {
      var ctx = this.ensureGraph();
      if (ctx.state === 'suspended') await ctx.resume();

      if (!this.playing) {
        try {
          this.source.start();
        } catch (e) {
          // AudioBufferSourceNode can only start once — ignore replay attempts
        }
        this.playing = true;
        this.playIcon.hidden = true;
        this.pauseIcon.hidden = false;
        this.updateStatus();
        this.draw();
      } else {
        await ctx.suspend();
        this.playing = false;
        this.playIcon.hidden = false;
        this.pauseIcon.hidden = true;
        this.updateStatus();
        if (this.raf) cancelAnimationFrame(this.raf);
      }
    }
  }

  if (!customElements.get('oblivion-noise-demo')) {
    customElements.define('oblivion-noise-demo', OblivionNoiseDemo);
  }
})();
